import * as React from "react";
import { ResponsiveBar } from "@nivo/bar";
import Typography from "@material-ui/core/Typography";
import { consts } from "../../common/consts";
import { line } from "d3-shape";
import "../../style/HQDashboard.css";
import Tooltip from "./BarChartWithTrendLineToolTip";
import { calcGridYValues } from "./helpers/dashboardHelpers";
const theme = {
    axis: {
        ticks: {
            text: {
                fill: "#fff",
                fontSize: "12px",
            },
        },
    },
    legends: {
        text: {
            fill: "#fff",
        },
    },
};




const BarChartWithTrendLine = (props: any) => {
    const maxVal = Math.max(...props.data.map((item: any) => {
        return item['value'];
    }));
    const [graphData, setGraphData] = React.useState<any[]>([]);

    const colors= props.colors ? props.colors:['#3B5E84'];

    React.useEffect(() => {
        let n = props.data.length;
        let a = 0;
        let sumX = 0;
        let sumY = 0;
        let sumXSquare = 0;
        let b = 0;
        let c = 0;
        let d = 0;
        for (let i = 0; i < props.data.length; i++) {
            a += ((i + 1) * props.data[i].value);
            sumX += (i + 1);
            sumY += props.data[i].value;
            sumXSquare += (i + 1) * (i + 1);
        }
        a = n * a;
        b = sumX * sumY;
        c = n * sumXSquare;
        d = sumX * sumX;
        let slope = ((a - b) / (c - d));
        let e = sumY;
        let f = slope * sumX;
        let yIntercept = ((e - f) / n);
        let newGraphData = [];
        for (let i = 0; i < props.data.length; i++) {
            newGraphData.push({
                index: i,
                name: props.data[i].name,
                value: props.data[i].value,
                lineValue: ((slope * (i + 1)) + yIntercept) < 0 ? 0 : ((slope * (i + 1)) + yIntercept)
            });
        }
        setGraphData(newGraphData);

    }, [props.data]);

    const TrendLineLayer = ({ bars, xScale, yScale }: { bars: any, xScale: any, yScale: any }) => {

        
        const lineGenerator = line()
            .x((d:any) => xScale((d.data.indexValue??0)) + (d.width??0) / 2)
            .y((d:any) => yScale(d.data.data.lineValue??0));
       
        return (
            //@ts-ignore
            <path d={lineGenerator(bars)} fill="none" stroke="rgba(255, 255, 255, 1)" strokeWidth="2" />
        );
    };
    return (
        <>
            {props.title && <div style={{ marginTop: "48px", marginLeft: "3em" }}>
                <Typography variant="h4">{props.title}</Typography>
            </div>}
            <div style={{ height: 250 }} className="bar_chart">
                <ResponsiveBar
                    data={graphData}
                    keys={['value']}
                    enableLabel={false}
                    isInteractive={true}
                    indexBy="name"
                    margin={{ top: 70, right: 50, bottom: 70, left: 60 }}
                    padding={0.85}
                    borderColor={{ theme: "background" }}
                    axisTop={null}
                    tooltip={Tooltip}
                    enableGridX={false}
                    enableGridY={true}
                    gridYValues={calcGridYValues(maxVal)}
                    axisRight={{
                        tickSize: 5,
                        tickValues: 3,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: "",
                        legendOffset: 0,
                    }}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: "",
                        legendPosition: "end",
                        legendOffset: 6,
                    }}
                    axisLeft={null}
                    theme={theme}
                    colors={colors}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
                  
                    animate={true}
                    motionStiffness={70}
                    motionDamping={15}
                    layers={["grid", "axes", "bars", TrendLineLayer, "markers", "legends"]}
                />
            </div>
        </>
    )
};

export default BarChartWithTrendLine;
